<template>
  <div
    class="w-imbee-header"
    :style="{
      color,
      fontSize,
      fontWeight,
      fontFamily,
      backgroundColor,
      boxShadow: `0px -10px 12px 8px ${backgroundColor}`,
      marginTop: headerMarginTop,
      position: 'relative',
      top: headerTop,
      left: headerLeft
    }"
  >
    <img v-if="showImage" :src="image" alt="Header image" :style="{ height: imageSize }"  />
    <span v-else>{{ text }}</span>
    
    <span 
      class="w-imbee-header-subtitle" 
      :style="subtitleStyles"
    >
      {{ subtitleText }}
    </span>

    <div
      v-if="showCloseButton && !fullScreen"
      @click="close"
      class="w-imbee-close-button"
    >
      <Close width="14px" height="14px" />
    </div>
  </div>
</template>

<script>
import Close from "../icons/Close2";

export default {
  name: "Header",
  components: {
    Close,
  },
  props: {
    text: { type: String, default: "" },
    image: { type: String, default: null },
    showImage: { type: Boolean, default: false },
    color: { type: String, default: "#000" },
    fontSize: { type: String, default: "16px" },
    fontWeight: { type: String, default: "normal" },
    fontFamily: { type: String, default: "Arial,Helvetica,sans-serif,Lato" },
    backgroundColor: { type: String, default: "#FFF" },
    fullScreen: { type: Boolean, default: false },
    headerTop: { type: String, default: "0px" },
    headerLeft: { type: String, default: "0px" },
    subtitleText: { type: String, default: "" },
    subtitleColor: { type: String, default: "#ee0000" },
    fontSubtitleSize: { type: String, default: "14px" },
    fontSubtitleWeight: { type: String, default: "bolder" },
    fontSubtitleFamily: { type: String, default: "Arial,Helvetica,sans-serif,Lato" },
    imageSize: { type: String, default: "80%" },
    subtitleTop: { type: String, default: "0px" },
    subtitleLeft: { type: String, default: "0px" }
  },
  data() {
    return {
      mediaQ: window.matchMedia("(max-width: 568px)"),
      showCloseButton: window.innerWidth < 568 ? true : false,
    };
  },
  computed: {
    subtitleStyles() {
      return {
        color: this.subtitleColor,
        fontSize: this.fontSubtitleSize,
        fontWeight: this.fontSubtitleWeight,
        fontFamily: this.fontSubtitleFamily,
        marginBottom: this.subtitleText.trim() !== "" ? "-6px" : "0px",
        position: 'relative',
        top: this.subtitleTop,
        left: this.subtitleLeft,
      };
    },
    headerMarginTop() {
      return this.subtitleText.trim() !== "" ? "10px" : "0px";
    }
  },
  methods: {
    handlerCloseButton(x) {
      this.showCloseButton = x.matches ? true : false;
    },
    close() {
      this.$emit("close");
    },
  },
  mounted() {
    this.mediaQ.addListener(this.handlerCloseButton);
  },
  beforeDestroy() {
    this.mediaQ.removeListener(this.handlerCloseButton);
  },
};
</script>

<style scoped>
@keyframes imbee-fadeIn {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.w-imbee-close-button {
  position: absolute !important;
  right: 16px !important;
  cursor: pointer;
  transition: all 0.3s ease;
  animation: imbee-fadeIn 0.6s ease;
}

.w-imbee-close-button:hover {
  transform: scale(1.18);
}

.w-imbee-header {
  z-index: 999;
  height: 60px;
  min-height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  border: none;
  background-color: rgb(250, 198, 84);
  position: relative;
}

.w-imbee-header-subtitle { 
  margin-bottom: -6px;
  line-height: 1.2;
  max-width: 90%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: inherit;
}

</style>



// WEBPACK FOOTER //
// Header.vue?30291206